import React from 'react'
import { useDeleteAllMasterInventoryMutation } from '../../Services/inventory/Inventory';
import useThemeColors from '../vehicle/ThemeColors';


interface IPROPS {
    closeModal: any;
    refetch: any;
    storeValue:any
    triggerDelete:any
}

const DeleteModal:React.FC<IPROPS> = ({closeModal, refetch, storeValue, triggerDelete}) => {



    const deleteFieldHandler = async(e) => {
        e.preventDefault()

        const deletePayload = {
            id: storeValue?.id ? storeValue?.id  : storeValue?.labour_id
        }

        const response = await triggerDelete(deletePayload)
        closeModal()
        refetch()

    }

         const {
                              selectedColor,
                              selectedBackgroundColor,
                              selectedBorderColor,
                              selectedButtonBackgoundColors,
                              selectedButtonColors,
                          } = useThemeColors();


  return (
   <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        alignItems: "center",
      }}
    >
      {/* <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "end",
        }}
      >
        <i
          style={{
            fontSize: "26px",
            color: "black",
            cursor: "pointer",
          }}
          className="bi bi-x"
          onClick={() => closeModal(true)}
        ></i>
      </div> */}
      <div style={{ color: "#3071e4", fontSize: "18px" }}>Are you sure?</div>
      <div style={{ marginBottom: "15px", fontSize: "16px" }}>
        Do you really want to delete these records? This process cannot be
        undone.
      </div>
      <div style={{ display: "flex", gap: "10px", width: "100%", justifyContent: "end" }}>
        <button onClick={deleteFieldHandler} style={{
                      background:  `${selectedButtonBackgoundColors}`,
                                color: `${selectedButtonColors}`,
                                border: "none",
                                padding: "10px 20px",
                                borderRadius: "20px",
                                fontSize: "15px",
        }}>
          Delete
        </button>
        <button className="btn btn-light" onClick={() => closeModal(true)}>
          Cancel
        </button>
      </div>
    </div>
  )
}

export default DeleteModal